import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyDto } from '@hub/generated/models';
import { CurrencyInputPipe } from '@hub/pipes/CurrencyInput.pipe';
import { eCurrency } from '@hub/generated/enums';

@Pipe({ name: 'showingAmount' })
export class ShowingAmountPipe implements PipeTransform {

	constructor() { }

	private currencyPipe: CurrencyInputPipe = new CurrencyInputPipe();

	transform(value: any, amount: number, currency: CurrencyDto): string {
		if (!!currency && value != 0) {
			if (currency.Currency == eCurrency.USD) {
				return (currency.Symbol) + ' ' + this.currencyPipe.transform(value.toString());
			} else {
				return (currency.Symbol) + ' ' + this.currencyPipe.transform(amount.toString()) + ' ($ ' + this.currencyPipe.transform(value.toString()) + ')';
			}
		}
	}
}
